export default "__VITE_ASSET__51f9ad36__"